// extracted by mini-css-extract-plugin
export default {"button":"Fp-z","reviewSort":"Gp-z"};